import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Anchor, Link } from '../components/AllSvgs'


const Container = styled.div`
  position: relative;
`;

const Slider = styled.div`
  position: fixed;
  top: 0;
  right: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transform: translateY(-100%);
  z-index: 5;
  gap: 0.2rem; /* Add consistent gap between chain links */
  
  .chain {
    transform: rotate(135deg);
  }
  
  /* Move anchor more to the right on FeatsPage */
  .feats-page & {
    right: 3rem;
    
    @media (max-width: 1200px) {
      right: 1rem;
      gap: 0.15rem;
    }
    
    @media (max-width: 768px) {
      right: 0.5rem;
      transform: scale(0.85) translateY(-100%);
      transform-origin: top right;
      gap: 0.1rem;
    }
    
    @media (max-width: 480px) {
      right: 1rem;
      transform: scale(0.7) translateY(-100%);
      transform-origin: top right;
      gap: 0.08rem;
    }
  }
`;

const AnchorComponents = (props) => {
  const ref = useRef(null);
  const isFeatsPage = props.page === 'feats';
  const [chainCount, setChainCount] = useState(props.numbers);

  useEffect(() => {
    const updateChainCount = () => {
      let baseCount = (window.innerHeight - 70) / 30;
      
      // Increase chain count for smaller screens
      if (window.innerWidth <= 480) {
        baseCount = baseCount * 1.5; // 50% more chains for mobile
      } else if (window.innerWidth <= 768) {
        baseCount = baseCount * 1.3; // 30% more chains for tablets
      }
      
      setChainCount(Math.floor(baseCount));
    };

    const handleScroll = () => {
      let scrollPosition = window.pageYOffset;
      let windowSize = window.innerHeight;
      let bodyHeight = document.body.offsetHeight;

      let diff = Math.max(bodyHeight - (scrollPosition + windowSize), 0);
      let diffP = (diff * 100) / (bodyHeight - windowSize);

      if (ref.current) {
        let scale = '1';
        if (window.innerWidth <= 480) {
          scale = '0.7';
        } else if (window.innerWidth <= 768) {
          scale = '0.85';
        }

        if (isFeatsPage) {
          ref.current.style.transform = `scale(${scale}) translateY(${-diffP}%)`;
        } else {
          ref.current.style.transform = `translateY(${-diffP}%)`;
        }
      }
    };

    // Initial updates
    updateChainCount();
    handleScroll();

    // Event listeners
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', () => {
      updateChainCount();
      handleScroll();
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [isFeatsPage]);

  const getChainSize = () => {
    if (window.innerWidth <= 480) {
      return { width: 18, height: 18 };
    } else if (window.innerWidth <= 768) {
      return { width: 22, height: 22 };
    }
    return { width: 25, height: 25 };
  };

  const getAnchorSize = () => {
    if (window.innerWidth <= 480) {
      return { width: 45, height: 45 };
    } else if (window.innerWidth <= 768) {
      return { width: 60, height: 60 };
    }
    return { width: 70, height: 70 };
  };

  return (
    <Container className={isFeatsPage ? 'feats-page' : ''}>
      <Slider ref={ref}>
        {[...Array(chainCount)].map((x, id) => {
          const size = getChainSize();
          return (
            <Link 
              key={id} 
              width={size.width} 
              height={size.height} 
              fill='currentColor' 
              className='chain'
            />
          );
        })}
        <Anchor 
          {...getAnchorSize()}
          fill='currentColor'
        />
      </Slider>
    </Container>
  );
};

export default AnchorComponents;
